export const ORGANIZATION_QUERY_KEYS = {
    current: ['org', 'current'] as const,
    all: ['org', 'all'] as const,
    businessHours: ['org', 'business-hours'] as const,
    quietHours: ['org', 'quiet-hours'] as const,
} as const;

export const CURRENCIES: { code: string; label: string; symbol: string }[] = [
    { code: 'USD', label: 'US Dollar (USD)', symbol: '$' },
    { code: 'EUR', label: 'Euro (EUR)', symbol: '€' },
    { code: 'GBP', label: 'British Pound (GBP)', symbol: '£' },
    { code: 'INR', label: 'Indian Rupee (INR)', symbol: '₹' },
    { code: 'CAD', label: 'Canadian Dollar (CAD)', symbol: 'CA$' },
    { code: 'AUD', label: 'Australian Dollar (AUD)', symbol: 'A$' },
    { code: 'SGD', label: 'Singapore Dollar (SGD)', symbol: 'S$' },
    { code: 'AED', label: 'UAE Dirham (AED)', symbol: 'AED' },
    { code: 'JPY', label: 'Japanese Yen (JPY)', symbol: '¥' },
    { code: 'CNY', label: 'Chinese Yuan (CNY)', symbol: '¥' },
    { code: 'BRL', label: 'Brazilian Real (BRL)', symbol: 'R$' },
    { code: 'MXN', label: 'Mexican Peso (MXN)', symbol: 'MX$' },
    { code: 'ZAR', label: 'South African Rand (ZAR)', symbol: 'R' },
    { code: 'NGN', label: 'Nigerian Naira (NGN)', symbol: '₦' },
    { code: 'KES', label: 'Kenyan Shilling (KES)', symbol: 'KSh' },
    { code: 'CHF', label: 'Swiss Franc (CHF)', symbol: 'CHF' },
    { code: 'SEK', label: 'Swedish Krona (SEK)', symbol: 'kr' },
    { code: 'NOK', label: 'Norwegian Krone (NOK)', symbol: 'kr' },
    { code: 'DKK', label: 'Danish Krone (DKK)', symbol: 'kr' },
    { code: 'NZD', label: 'New Zealand Dollar (NZD)', symbol: 'NZ$' },
];

export const COUNTRY_CURRENCY_MAP: Record<string, string> = {
    US: 'USD',
    GB: 'GBP',
    IN: 'INR',
    EU: 'EUR',
    DE: 'EUR',
    FR: 'EUR',
    IT: 'EUR',
    ES: 'EUR',
    NL: 'EUR',
    CA: 'CAD',
    AU: 'AUD',
    SG: 'SGD',
    AE: 'AED',
    JP: 'JPY',
    CN: 'CNY',
    BR: 'BRL',
    MX: 'MXN',
    ZA: 'ZAR',
    NG: 'NGN',
    KE: 'KES',
    CH: 'CHF',
    SE: 'SEK',
    NO: 'NOK',
    DK: 'DKK',
    NZ: 'NZD',
};

export const ALLOWED_LOGO_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
export const MAX_LOGO_SIZE_BYTES = 5 * 1024 * 1024; // 5MB

/**
 * Limits on what is typed into the organization profile — each input stops at
 * its limit (`maxLength`) and says so. `streetAddress` mirrors the API's
 * `@MaxLength`; the others are the form's own, below the API's (website 500,
 * city 100, ZIP 20), so a longer value already saved keeps working and only new
 * input is held to them.
 */
export const ORGANIZATION_FIELD_LIMITS = {
    // Room for a real deep link, well under the API's 500. Onboarding's website
    // input uses the same number.
    website: 255,
    streetAddress: 255,
    // Fits long official city names ("Heroica Ciudad de Juchitán de Zaragoza" is
    // 38, "Llanfairpwllgwyngyll…gogogoch" 58); the API allows 100.
    city: 60,
    // The longest national format ("94102-1234", US ZIP+4) and the generic rule's
    // ceiling in `address-formats.ts`; the API allows 20.
    zipCode: 10,
} as const;

/** Maps ISO 4217 currency code → ISO 3166-1 alpha-2 country code (lowercase) for flag display */
export const CURRENCY_COUNTRY_MAP: Record<string, string> = {
    USD: 'us',
    GBP: 'gb',
    INR: 'in',
    CAD: 'ca',
    AUD: 'au',
    SGD: 'sg',
    AED: 'ae',
    JPY: 'jp',
    CNY: 'cn',
    BRL: 'br',
    MXN: 'mx',
    ZAR: 'za',
    NGN: 'ng',
    KES: 'ke',
    CHF: 'ch',
    SEK: 'se',
    NOK: 'no',
    DKK: 'dk',
    NZD: 'nz',
    EUR: 'eu',
};
